import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <img {...{
      "src": "./../images/ibm/1_CXk3Ocs_Gizl684EP5YC7Q.png",
      "alt": "ibm"
    }}></img>
    <p>{`In this chapter you will install resources that are needed for the configuration of CP4AIOPS in the next chapter.`}</p>
    <p>{`Those are `}<strong parentName="p">{`assets that typically already exist at a customer`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul">{`ELK - for Log Collection`}</li>
      <li parentName="ul">{`OpenLDAP - for Authentication`}</li>
      <li parentName="ul">{`AWX (Open Source Ansible Tower) with preloaded Playbooks - for Runbook Automation`}</li>
      <li parentName="ul">{`RobotShop Demo App`}</li>
    </ul>
    <p>{`This will also load training data for:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Log Anomalies`}</strong>{`\\
You will integrate with your live ELK instance but you probably don’t have 2-3 days to wait for ELK to collect enough logs.
So we’ll train on this pre-canned Log Data.`}</li>
      <li parentName="ul"><strong parentName="li">{`Metric Anomalies`}</strong>{`\\
For this training we won’t have a Metric provider (Instana, …) so we’ll train on pre-canned Metric Data.
If you want you can always integrate an existing Metric Source on top of the provided training data.`}</li>
      <li parentName="ul"><strong parentName="li">{`Service Now`}</strong>{` - Similar Incidents\\
For this training we won’t have a Service Now Instance so we’ll train on pre-canned SNOW Data.
If you want you can always integrate an existing SNOW instance on top of the provided training data.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      